import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  DialogActions,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from '@mui/material';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import HeaderWithActions from '../../../../../../../lib/designSystem/HeaderWithActions';
import EnhancedTable from '../../../../../../../lib/designSystem/Table';
import { createFundOwnCollection } from '../../../../../../../lib/api/funds';
import {
  formatDate,
  showAlert,
} from '../../../../../../../lib/functions/utils';

const MultiOwnCollection = (props: any) => {
  const {
    open,
    setOpen,
    payments,
    setSelected,
    callBackCreatePendingAccounts,
  } = props;
  const dispatch = useDispatch();
  const newOperationDate = new Date();
  // Set to 12:00:00
  newOperationDate.setUTCHours(12);
  const [openOwnCollection, setOpenOwnCollection] = useState(false);
  const [paymentDate, setPaymentDate] = useState<any>(newOperationDate);

  const handleOwnCollection = async () => {
    try {
      const paymentsWithDate = payments.map((payment: any) => ({
        ...payment,
      }));
      const { factoringResellsPaid, date } = await createFundOwnCollection(
        dispatch,
        {
          factoringNewResells: paymentsWithDate,
        },
      );
      showAlert(
        dispatch,
        'success',
        'Facturas registradas como recaudación propia correctamente. Se creó una cuenta por pagar al fondo para cada factura.',
      );
      setOpen(false);
      setSelected([]);
      await callBackCreatePendingAccounts(factoringResellsPaid, date);
    } catch (error) {
      setOpen(false);
      showAlert(
        dispatch,
        'error',
        'Error al registrar facturas como recaudación propia',
      );
      setSelected([]);
    }
  };

  const DateSelector = () => {
    return (
      <div>
        <TextField
          label="Fecha"
          value={paymentDate ? formatDate(paymentDate) : null}
          type="date"
          onChange={(event) => setPaymentDate(event.target.value)}
        />
      </div>
    );
  };

  return (
    <Dialog maxWidth="md" fullWidth open={open}>
      <div style={{ padding: 20, minHeight: 200 }}>
        <div>
          <HeaderWithActions
            title="Registrar recaudación propia"
            item={DateSelector()}
          />
          <div style={{ padding: '10px 0px' }}>
            <EnhancedTable
              data={payments}
              dataHeaders={[
                {
                  key: 'factoringResellId',
                  label: 'Id',
                  type: 'numeric-id',
                },
                {
                  key: 'folio',
                  label: 'Folio',
                },
                {
                  key: 'businessName',
                  label: 'Cliente',
                },
                {
                  key: 'stakeholderName',
                  label: 'Deudor',
                },
                {
                  key: 'fundName',
                  label: 'Fondo',
                },
                {
                  key: 'documentAmount',
                  label: 'Monto Documento',
                  type: 'money',
                },
              ]}
            />
          </div>
          <DialogActions>
            <CustomButton onClick={() => setOpen(false)} color="secondary">
              Salir
            </CustomButton>
            <CustomButton
              onClick={() => setOpenOwnCollection(true)}
              color="primary"
            >
              Registrar
            </CustomButton>
          </DialogActions>
        </div>
      </div>
      <Dialog
        open={openOwnCollection}
        onClose={() => setOpenOwnCollection(false)}
      >
        <DialogTitle>
          <Typography variant="h6">Registrar recaudación propia</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Estás seguro de querer registrar las facturas como recaudación
            propia?
          </Typography>
        </DialogContent>
        <DialogActions>
          <CustomButton
            onClick={() => setOpenOwnCollection(false)}
            color="secondary"
          >
            Cancelar
          </CustomButton>
          <CustomButton onClick={() => handleOwnCollection()} color="primary">
            Confirmar
          </CustomButton>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default MultiOwnCollection;
